module.exports = __webpack_public_path__ + "static/media/pic1@2x.fded511e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/pic1@2x.png
// module id = 1413
// module chunks = 0